import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { SharedComponentsModule } from '../../shared/component/shared.components.module';
import { DetailViewComponent } from './detail-view.component';
import { FormBuilderComponent } from './form-builder/form-builder.component';
import { RelatedTableComponent } from './related-table/related-table.component';
import { RelatedFeatureFormComponent } from './related-table/related-feature-form/related-feature-form.component';
import { PartFeaturesTableComponent } from './part-features-table/part-features-table.component';
import { AttachmentsViewComponent } from './attachments-view/attachments-view.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { SharedModule } from '../../shared/shared.module';
import { ResizableModule } from 'angular-resizable-element';
import { DragDropModule } from 'src/app/core/drag-drop/drag-drop.module';
import { RelatedTableActionsService } from './related-table/shared/related-table-actions.service';
import { FormControlsModule } from './form-controls/form-controls.module';
import { CommonModule } from '@angular/common';
import {
  DenkmalpflegeMessageComponent
} from "./denkmalpflege-message/denkmalpflege-message.component";
import {DetailViewHeaderComponent} from "./detail-view-header/detail-view-header.component";

export const DETAIL_VIEW_COMPONENTS = [
  AttachmentsViewComponent,
  RelatedFeatureFormComponent,
  RelatedTableComponent,
  DetailViewComponent,
  FormBuilderComponent,
  PartFeaturesTableComponent,
  DenkmalpflegeMessageComponent,
  DetailViewHeaderComponent
];

@NgModule({
  declarations: [DETAIL_VIEW_COMPONENTS],
  imports: [
    TranslateModule,
    CommonModule,
    FormControlsModule,
    FormsModule,
    ReactiveFormsModule,
    TabsModule,
    TypeaheadModule.forRoot(),
    SharedComponentsModule,
    SharedModule,
    NgxDatatableModule,
    ResizableModule,
    DragDropModule,
  ],
  exports: [DETAIL_VIEW_COMPONENTS, FormControlsModule],
  providers: [RelatedTableActionsService],
})
export class DetailViewModule {}
